import React, { useMemo } from 'react';
import { isAllFeed } from '../utils';
import { useSelector } from 'react-redux';
import { getIsCategoryFilterApplied } from '../redux/selectors/options';

export const FeedInfoContext = React.createContext<{
  streamId: string;
  isFilteredBySubnav: boolean;
  isFakeAllFeed: boolean;
}>({ streamId: '', isFilteredBySubnav: false, isFakeAllFeed: false });
FeedInfoContext.displayName = 'FeedInfoContext';

export const FeedInfoContextProvider: React.FC<{
  streamId: string;
  children?: React.ReactNode;
}> = ({ streamId, children }) => {
  const isCategoryFilterApplied = useSelector(getIsCategoryFilterApplied);
  const isFakeAllFeed = isAllFeed(streamId);
  const feedInfoContextValue = useMemo(
    () => ({
      isFilteredBySubnav: isCategoryFilterApplied,
      isFakeAllFeed,
      streamId,
    }),
    [isCategoryFilterApplied, isFakeAllFeed, streamId]
  );

  return (
    <FeedInfoContext.Provider value={feedInfoContextValue}>
      {children}
    </FeedInfoContext.Provider>
  );
};
